import { c as _c } from "react/compiler-runtime";
import type { RefObject } from "react";
import type { ApiCreateGroup } from "@/generated/models/ApiCreateGroup";
import type { ApiGroupFull } from "@/generated/models/ApiGroupFull";
import type { ApiIdentity } from "@/generated/models/ApiIdentity";
import { CreateWaveStep } from "@/types/waves.types";
import CreateWaveDates from "./dates/CreateWaveDates";
import type { CreateWaveDescriptionHandles } from "./description/CreateWaveDescription";
import CreateWaveDescription from "./description/CreateWaveDescription";
import CreateWaveDrops from "./drops/CreateWaveDrops";
import CreateWaveGroups from "./groups/CreateWaveGroups";
import type { useWaveConfig } from "./hooks/useWaveConfig";
import CreateWaveOutcomes from "./outcomes/CreateWaveOutcomes";
import CreateWaveOverview from "./overview/CreateWaveOverview";
import CreateWaveVoting from "./voting/CreateWaveVoting";
type WaveConfigController = ReturnType<typeof useWaveConfig>;
export default function CreateWaveStepContent(t0) {
  const $ = _c(75);
  const {
    controller,
    profile,
    descriptionRef,
    submitting,
    showDropError,
    onHaveDropToSubmitChange,
    onInlineGroupCreate
  } = t0;
  const {
    config,
    step,
    selectedOutcomeType,
    errors,
    groupsCache,
    isMemeCountLoading,
    isMemeCountError,
    setOverview,
    setDates,
    setDrops,
    setOutcomes,
    setDisplay,
    setDropsAdminCanDelete,
    onOutcomeTypeChange,
    onGroupSelect,
    onVotingTypeChange,
    onCategoryChange,
    onProfileIdChange,
    onCreditNftsChange,
    onCreditScopeChange,
    onMaxVotesPerIdentityPerDropChange,
    onAllowNegativeVotesChange,
    onTimeWeightedVotingChange,
    onThresholdChange,
    onThresholdTimeChange,
    onApprovalMaxWinnersChange,
    onChatEnabledChange
  } = controller;
  switch (step) {
    case CreateWaveStep.OVERVIEW:
      {
        let t1;
        if ($[0] !== config.display || $[1] !== config.overview || $[2] !== errors || $[3] !== setDisplay || $[4] !== setOverview) {
          t1 = <CreateWaveOverview overview={config.overview} display={config.display} errors={errors} setOverview={setOverview} setDisplay={setDisplay} />;
          $[0] = config.display;
          $[1] = config.overview;
          $[2] = errors;
          $[3] = setDisplay;
          $[4] = setOverview;
          $[5] = t1;
        } else {
          t1 = $[5];
        }
        return t1;
      }
    case CreateWaveStep.GROUPS:
      {
        let t1;
        if ($[6] !== config.chat.enabled || $[7] !== config.drops.adminCanDeleteDrops || $[8] !== config.groups || $[9] !== config.overview.name || $[10] !== config.overview.type || $[11] !== groupsCache || $[12] !== onChatEnabledChange || $[13] !== onGroupSelect || $[14] !== onInlineGroupCreate || $[15] !== setDropsAdminCanDelete) {
          t1 = <CreateWaveGroups waveName={config.overview.name} waveType={config.overview.type} groups={config.groups} groupsCache={groupsCache} chatEnabled={config.chat.enabled} adminCanDeleteDrops={config.drops.adminCanDeleteDrops} setChatEnabled={onChatEnabledChange} onGroupSelect={onGroupSelect} onInlineGroupCreate={onInlineGroupCreate} setDropsAdminCanDelete={setDropsAdminCanDelete} />;
          $[6] = config.chat.enabled;
          $[7] = config.drops.adminCanDeleteDrops;
          $[8] = config.groups;
          $[9] = config.overview.name;
          $[10] = config.overview.type;
          $[11] = groupsCache;
          $[12] = onChatEnabledChange;
          $[13] = onGroupSelect;
          $[14] = onInlineGroupCreate;
          $[15] = setDropsAdminCanDelete;
          $[16] = t1;
        } else {
          t1 = $[16];
        }
        return t1;
      }
    case CreateWaveStep.DATES:
      {
        let t1;
        if ($[17] !== config.dates || $[18] !== config.overview.type || $[19] !== errors || $[20] !== setDates) {
          t1 = <CreateWaveDates waveType={config.overview.type} dates={config.dates} errors={errors} setDates={setDates} />;
          $[17] = config.dates;
          $[18] = config.overview.type;
          $[19] = errors;
          $[20] = setDates;
          $[21] = t1;
        } else {
          t1 = $[21];
        }
        return t1;
      }
    case CreateWaveStep.DROPS:
      {
        let t1;
        if ($[22] !== config.drops || $[23] !== config.overview.type || $[24] !== errors || $[25] !== setDrops) {
          t1 = <CreateWaveDrops waveType={config.overview.type} drops={config.drops} errors={errors} setDrops={setDrops} />;
          $[22] = config.drops;
          $[23] = config.overview.type;
          $[24] = errors;
          $[25] = setDrops;
          $[26] = t1;
        } else {
          t1 = $[26];
        }
        return t1;
      }
    case CreateWaveStep.VOTING:
      {
        let t1;
        if ($[27] !== config.approval.threshold || $[28] !== config.approval.thresholdTimeMs || $[29] !== config.overview.type || $[30] !== config.voting.allowNegativeVotes || $[31] !== config.voting.category || $[32] !== config.voting.creditNftMemeCount || $[33] !== config.voting.creditNfts || $[34] !== config.voting.creditScope || $[35] !== config.voting.maxVotesPerIdentityPerDrop || $[36] !== config.voting.profileId || $[37] !== config.voting.timeWeighted || $[38] !== config.voting.type || $[39] !== errors || $[40] !== isMemeCountError || $[41] !== isMemeCountLoading || $[42] !== onAllowNegativeVotesChange || $[43] !== onCategoryChange || $[44] !== onCreditNftsChange || $[45] !== onCreditScopeChange || $[46] !== onMaxVotesPerIdentityPerDropChange || $[47] !== onProfileIdChange || $[48] !== onThresholdChange || $[49] !== onThresholdTimeChange || $[50] !== onTimeWeightedVotingChange || $[51] !== onVotingTypeChange) {
          t1 = <CreateWaveVoting waveType={config.overview.type} selectedType={config.voting.type} category={config.voting.category} profileId={config.voting.profileId} creditNfts={config.voting.creditNfts} creditScope={config.voting.creditScope} memeCount={config.voting.creditNftMemeCount} isMemeCountLoading={isMemeCountLoading} isMemeCountError={isMemeCountError} allowNegativeVotes={config.voting.allowNegativeVotes} maxVotesPerIdentityPerDrop={config.voting.maxVotesPerIdentityPerDrop} approvalThreshold={config.approval.threshold} approvalThresholdTimeMs={config.approval.thresholdTimeMs} errors={errors} onTypeChange={onVotingTypeChange} setCategory={onCategoryChange} setProfileId={onProfileIdChange} setCreditNfts={onCreditNftsChange} onCreditScopeChange={onCreditScopeChange} onAllowNegativeVotesChange={onAllowNegativeVotesChange} setMaxVotesPerIdentityPerDrop={onMaxVotesPerIdentityPerDropChange} setApprovalThreshold={onThresholdChange} setApprovalThresholdTimeMs={onThresholdTimeChange} timeWeighted={config.voting.timeWeighted} onTimeWeightedChange={onTimeWeightedVotingChange} />;
          $[27] = config.approval.threshold;
          $[28] = config.approval.thresholdTimeMs;
          $[29] = config.overview.type;
          $[30] = config.voting.allowNegativeVotes;
          $[31] = config.voting.category;
          $[32] = config.voting.creditNftMemeCount;
          $[33] = config.voting.creditNfts;
          $[34] = config.voting.creditScope;
          $[35] = config.voting.maxVotesPerIdentityPerDrop;
          $[36] = config.voting.profileId;
          $[37] = config.voting.timeWeighted;
          $[38] = config.voting.type;
          $[39] = errors;
          $[40] = isMemeCountError;
          $[41] = isMemeCountLoading;
          $[42] = onAllowNegativeVotesChange;
          $[43] = onCategoryChange;
          $[44] = onCreditNftsChange;
          $[45] = onCreditScopeChange;
          $[46] = onMaxVotesPerIdentityPerDropChange;
          $[47] = onProfileIdChange;
          $[48] = onThresholdChange;
          $[49] = onThresholdTimeChange;
          $[50] = onTimeWeightedVotingChange;
          $[51] = onVotingTypeChange;
          $[52] = t1;
        } else {
          t1 = $[52];
        }
        return t1;
      }
    case CreateWaveStep.APPROVAL:
      {
        return null;
      }
    case CreateWaveStep.OUTCOMES:
      {
        let t1;
        if ($[53] !== config.approval.maxWinners || $[54] !== config.dates || $[55] !== config.outcomes || $[56] !== config.overview.type || $[57] !== errors || $[58] !== onApprovalMaxWinnersChange || $[59] !== onOutcomeTypeChange || $[60] !== selectedOutcomeType || $[61] !== setOutcomes) {
          t1 = <CreateWaveOutcomes outcomes={config.outcomes} outcomeType={selectedOutcomeType} waveType={config.overview.type} errors={errors} dates={config.dates} maxWinners={config.approval.maxWinners} setOutcomeType={onOutcomeTypeChange} setOutcomes={setOutcomes} setMaxWinners={onApprovalMaxWinnersChange} />;
          $[53] = config.approval.maxWinners;
          $[54] = config.dates;
          $[55] = config.outcomes;
          $[56] = config.overview.type;
          $[57] = errors;
          $[58] = onApprovalMaxWinnersChange;
          $[59] = onOutcomeTypeChange;
          $[60] = selectedOutcomeType;
          $[61] = setOutcomes;
          $[62] = t1;
        } else {
          t1 = $[62];
        }
        return t1;
      }
    case CreateWaveStep.DESCRIPTION:
      {
        let t1;
        if ($[63] !== config.overview.image) {
          t1 = config.overview.image ? URL.createObjectURL(config.overview.image) : null;
          $[63] = config.overview.image;
          $[64] = t1;
        } else {
          t1 = $[64];
        }
        let t2;
        if ($[65] !== config.overview.name || $[66] !== t1) {
          t2 = {
            name: config.overview.name,
            image: t1,
            id: null
          };
          $[65] = config.overview.name;
          $[66] = t1;
          $[67] = t2;
        } else {
          t2 = $[67];
        }
        let t3;
        if ($[68] !== descriptionRef || $[69] !== onHaveDropToSubmitChange || $[70] !== profile || $[71] !== showDropError || $[72] !== submitting || $[73] !== t2) {
          t3 = <CreateWaveDescription ref={descriptionRef} profile={profile} submitting={submitting} showDropError={showDropError} wave={t2} onHaveDropToSubmitChange={onHaveDropToSubmitChange} />;
          $[68] = descriptionRef;
          $[69] = onHaveDropToSubmitChange;
          $[70] = profile;
          $[71] = showDropError;
          $[72] = submitting;
          $[73] = t2;
          $[74] = t3;
        } else {
          t3 = $[74];
        }
        return t3;
      }
  }
  return null;
}